import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import PropertyHero from "./Hero";
import PropertyDetails from "./Details";

const Property = () => {
  const { id } = useParams();

  useEffect(() => {
    AOS.init({  
      duration: 800,
      easing: "ease-out",
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <Box>
      <Navbar />
      <PropertyHero />
      <PropertyDetails />
      <Footer />
    </Box>
  );
};

export default Property;
